import React from 'react';
import { Box } from '@abyss/web/ui/Box';
import { Label } from '@abyss/web/ui/Label';
import { Button } from '@abyss/web/ui/Button';
import { useRouter } from '@abyss/web/hooks/useRouter';
import { IconSymbol } from '@abyss/web/ui/IconSymbol';
import { Link } from '@abyss/web/ui/Link';

export const Logout = () => {
    const { navigate } = useRouter();

    const goHome = () => {
        navigate('/');
    };

    return (
        <Box
            padding={40}
            css={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '20px',
                minHeight: '60vh',
                maxWidth: '50vw',
                backgroundColor: 'white',
            }}
        >
            <IconSymbol
                icon="logout"
                color="$primary1"
                size="96px"
                variant="outlined"
            />
            <Label size="xl" fontWeight="$bold" color="$primary1" css={{ textAlign: 'center' }}>
                You have been logged out
            </Label>

            <Label
                size="md"
                color="$gray6"
                css={{ textAlign: 'center', maxWidth: '500px' }}
            >
                Your session has expired. <Link href="/login">Click here.</Link> to be redirected to the login page.
            </Label>

            {/* <Button variant="solid" size="lg" onClick={goHome}>
                Go Home
            </Button> */}
        </Box>
    );
};
